import { HStack, Text } from "@chakra-ui/react";

export const NotApplicable = () => (
  <HStack h={8} alignItems={"start"}>
    <Text fontSize={"xs"} opacity={0.6}>
      N/A
    </Text>
  </HStack>
);
